import { isValidEmail } from 'shared/utils/validators';
import { withLocalePrefix } from 'shared/utils/translation';
import { DropdownOption } from 'candidate_profile_redesign/shared/form/Fields';
const t = withLocalePrefix('candidate_profile_redesign.modals.email');

export const validCreatedEmails = (options: DropdownOption[]) => {
  const firstInvalidOption = options.find((option) => {
    return option.userCreated && !isValidEmail(option.label);
  });

  if (!firstInvalidOption) {
    return true;
  }

  if (options.length > 1) {
    return t('contains_invalid_email');
  }

  return t('invalid_email');
};
